export const v2MenuItemSizeClass = {
    small: 'ov-v2-menu-item--sm',
    large: 'ov-v2-menu-item--lg',
};
export const v2MenuItemDangerClass = 'ov-v2-menu-item--danger';
